import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import AboutUs from "./components/AboutUs";

function App() {
  return (
    <div>
      <Navbar />
      <div id="hero">
        <Hero />
      </div>
      <div id="about">
        <AboutUs/>
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="contact">
        <Contact/>
      </div>
      <Footer />
    </div>
  );
}

export default App;